import React, { createContext, useCallback, useEffect, useState } from "react";
import * as auth from "./auth";
//import LoadingPage from "../components/LoadingPage";

export const AuthenticationContext = createContext();

const AuthProvider = (props) => {
  const [user, setUser] = useState(null);
  const [fetched, setFetched] = useState(false);

  const login = async (username, password) => {
    return await auth.login(username, password).then((data) => {
      setUser(data.data);
    });
  };

  const register = async (data) => {
    return await auth.register(data);
  };

  const logout = async () => {
    setUser(null);
    await auth.logout().then(() => {
      window.location = "/";
    });
  };

  const getUser = useCallback(async () => {
    const user = await auth.getUser();
    setUser(user ? user.data : null);
  }, []);

  if (!fetched) {
    getUser().then(() => setFetched(true));
  }

  /* if (!fetched) {
    return <LoadingPage />;
  } */

  useEffect(() => {
    let debounceTimer = null;

    const checkToken = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const currUser = JSON.parse(localStorage.getItem("user"));
        if (currUser) {
          getUser(); // refreshes token if expired, logs out if refresh fails
        }
      }, 300);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkToken();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", checkToken);

    return () => {
      clearTimeout(debounceTimer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", checkToken);
    };
  }, [getUser]);

  return (
    <AuthenticationContext.Provider
      value={{
        user,
        login,
        logout,
        getUser,
        setUser,
        register,
      }}
    >
      {props.children}
    </AuthenticationContext.Provider>
  );
};

export { AuthProvider };
